import { Component, computed, inject, input, output, signal } from '@angular/core';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { AssetsService, I18nService, NavButtonComponent, UiService } from '@lp-ui-lib';

@Component({
  selector: 'app-health-status-info-popup',
  imports: [NzModalModule, NzIconModule, NavButtonComponent],
  templateUrl: './health-status-info-popup.html',
  styleUrls: ['./health-status-info-popup.scss'],
})
export class HealthStatusInfoPopupComponent {
  public i18n = inject(I18nService);
  private assetsService = inject(AssetsService);
  public ui = inject(UiService);
  modalOpen = input<boolean>(false);
  asset = input<any>(null);
  public closeButton = output<void>();

  public isMobile = computed(() => this.ui.IsMobile());
  healthStatusRows = signal([
    {
      icon: 'icons:status-check',
      status: this.i18n.langString('status_working_fine'),
      statusClass: 'working',
      rul: this.i18n.langString('rul_criteria_working'),
      suggestion: this.i18n.langString('suggestion_action_working'),
    },
    {
      icon: 'icons:status-exclamation-octagon',
      status: this.i18n.langString('status_attention_needed'),
      statusClass: 'warning',
      rul: this.i18n.langString('rul_criteria_warning'),
      suggestion: this.i18n.langString('suggestion_action_warning'),
    },
    {
      icon: 'icons:status-exclamation-triangle',
      status: this.i18n.langString('status_critical_condition'),
      statusClass: 'critical',
      rul: this.i18n.langString('rul_criteria_critical'),
      suggestion: this.i18n.langString('suggestion_action_critical'),
    },
  ]);

  cancelClick(): void {
    this.closeButton.emit();
  }

  goToNanoPreciseDashboard(): void {
    const windowReference: any = window.open('about:blank', '_blank');
    const assetVal = this.asset();
    if (!assetVal) return;

    this.assetsService.goToNanoPreciseDashboard(assetVal.objectID).then((result: any) => {
      if (result?.result) {
        windowReference.location = result.result;
      }
    });
  }
}
